import React from 'react';

import { Typography } from '@scale/scaleui';
import { ISensorFusionUnifiedProjectLookupDto } from '@scale/sensor-fusion-shared';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

import { useSensorFusionLookupContext } from '../contexts/SensorFusionLookupContext';
import {
  COMPLETE_SUBSTAGES_CORP_TOOL_PATH,
  QM_PROJECT_LOOKUP_PATH,
  BATCH_ACTIONS_CORP_TOOL_PATH,
} from '../constants';
import RemotasksExternalLink from 'react-scale/corp/components/UI/RemotasksExternalLink';

type SfuProjectToolsPanelProps = {
  project: ISensorFusionUnifiedProjectLookupDto;
};

const ToolBarLink = ({ title, link }: { title: string; link: string }) => (
  <li>
    <a className="text-info-700" href={link}>
      {title}
    </a>
  </li>
);

const SfuProjectToolsPanel = ({ project }: SfuProjectToolsPanelProps) => {
  const { scaleDashboardFrontendUrl } = useSensorFusionLookupContext() ?? {};
  const { isRemoAdmin } = useRemoAdminCtx();

  // TODO: Should fix the following urls when enable the tools for remoadmins, see the task tracker below
  const legacyProjectUrl = `${scaleDashboardFrontendUrl ?? ''}/${QM_PROJECT_LOOKUP_PATH}/${
    project._id
  }`;
  const completeSubstagesUrl = `${
    scaleDashboardFrontendUrl ?? ''
  }/${COMPLETE_SUBSTAGES_CORP_TOOL_PATH}`;

  const batchActionUrl = `${scaleDashboardFrontendUrl ?? ''}/${BATCH_ACTIONS_CORP_TOOL_PATH}`;

  // accessible on legacy, but vital for queue management
  const pipelineConfigEditorUrl = `${scaleDashboardFrontendUrl ?? ''}/${QM_PROJECT_LOOKUP_PATH}/${
    project._id
  }/pipeline`;

  const dataEngineLink = `${scaleDashboardFrontendUrl}/data-engine/${project._id}?spoof=${project.customer.id}&project=${project._id}`;

  const remoAdminSfuProjectUrl = `/sensorfusion/remoadmin/project/${project._id}/home`;
  const scaleSfuProjectUrl = `/sensorfusion/ops-hub/project/${project._id}/home`;

  return (
    <div className="border border-solid border-neutral-200 px-4 py-4 flex flex-col gap-2">
      <Typography.H3>Tools</Typography.H3>
      <ul className="flex flex-col ml-2 gap-1">
        {isRemoAdmin ? (
          <RemotasksExternalLink path={remoAdminSfuProjectUrl}>
            View in SFU Ops Dashboard
          </RemotasksExternalLink>
        ) : (
          <ToolBarLink title="View in SFU Ops Dashboard" link={scaleSfuProjectUrl} />
        )}
        {!isRemoAdmin && (
          <>
            <ToolBarLink title="View as legacy project" link={legacyProjectUrl} />
            <ToolBarLink title="Complete Substage Instances" link={completeSubstagesUrl} />
          </>
        )}

        {!isRemoAdmin && (
          <>
            <ToolBarLink title="Pipeline Config Editor" link={pipelineConfigEditorUrl} />
            <ToolBarLink title="Batch Actions" link={batchActionUrl} />
            <ToolBarLink title="View in Data Engine" link={dataEngineLink} />
          </>
        )}
      </ul>
    </div>
  );
};

export default SfuProjectToolsPanel;
